module.exports = __webpack_public_path__ + "img/logo@2x.f30c689b.png";